import { useMemo } from "react";
import { Outlet, useParams } from "react-router-dom";

import { Navigate } from "@/components/navigation-controls/navigate";
import { NotFoundView } from "@/components/not-found-view";
import { useTeamListForWorkspace } from "@/domain/team/hooks/api/use-team-list-for-workspace";
import { useCurrentUserContext } from "@/domain/user/hooks/use-current-user-context";
import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";

import { CurrentTeamListContextProvider } from "../../hooks/use-current-team-list-context";

export function TeamListSettingsLayout() {
  const { currentUser } = useCurrentUserContext();

  const { teamId } = useParams();
  const { currentWorkspace } = useCurrentWorkspaceContext();
  const { activeTeamList } = useTeamListForWorkspace({
    workspaceId: currentWorkspace.id,
    userId: currentUser?.id,
  });

  const nextTeam = useMemo(() => {
    if (activeTeamList.length === 0) {
      return null;
    }

    return activeTeamList[0];
  }, [activeTeamList]);

  if (!currentWorkspace.workspaceUrl) {
    return <NotFoundView />;
  }

  if (!teamId) {
    if (!nextTeam) {
      return <NotFoundView />;
    }

    return <Navigate to={`/${currentWorkspace.workspaceUrl}/settings/teams/${nextTeam.id}`} replace={true} />;
  }

  return (
    <CurrentTeamListContextProvider userId={currentUser?.id} workspaceId={currentWorkspace.id}>
      <Outlet />
    </CurrentTeamListContextProvider>
  );
}
